import {Redirect, Route, Switch} from "react-router-dom";
import {Layout} from "antd";
import AppHeader from "../../parts/AppHeader";
import {ApplicationList} from "../../pages/applications/applicationList";
import {ApplicationDetail} from "../../pages/applications/applicationDetail";
import {Routes} from "../../common/Routes";
import React, {useEffect, useState} from "react";
import {initClient} from "../matomoClient";
import {UserPage} from "../../pages/users";
import {loadFeatureToggles} from "../../FeatureToggles";
import {getUserInfo, logout} from "../authentication/oktaConfig";
import UserGroups from "../../pages/userGroups";
import {UserDetailController} from "../../pages/users/userDetail/controller";
import {isEmpty, isNullOrUndefined} from "../../common/utils";
import KeyCondition from "../../pages/userGroups/KeyCondition";
import PreviewKeyCondition from "../../pages/userGroups/PreviewKeyCondition";
import AppSidebar from "../../parts/AppSideBar";
import "./index.scss";
import {InformationAssetDetail} from "../../pages/information-assets/information-asset-detail";
import {SystemUserGroupDetail} from "../../pages/information-assets/system-user-group-detail";
import {UserGuide} from "../../pages/user-guide";
import {LandingComponent} from "../../pages/users/userDetail";
import {InformationAssetsUnderConstruction} from "../../pages/information-assets/under-construction";
import Qualaroo from "../qualaroo";
import {PolicyDetail} from "../../pages/policies";
import ManagePolicy from "../../pages/policies/managePolicy/managePolicy";

export const App = () => {
  const {currentUser} = UserDetailController();
  const [firstName, setFirstName] = useState();

  loadFeatureToggles();

  useEffect(() => {
      const {firstName} = getUserInfo();
      setFirstName(firstName);
      if (!isNullOrUndefined(currentUser) && !isEmpty(currentUser)) {
        initClient(currentUser);
      }
    }
    , [currentUser]);

  const getHomePageComponent = () => {
    return LandingComponent;
  };

  return (
    <div className={"App"}>
      <div className="overlay-root"></div>
      <Layout>
        <AppSidebar/>
        <Layout.Content style={{minHeight: "100vh", backgroundColor: "white"}}>
          <AppHeader
            logout={logout}
            name={firstName}
          />
          <Qualaroo userDetails={currentUser}/>
          <Switch>
            <Route
              path={Routes.Applications.path}
              component={ApplicationList}
              exact={true}
            />
            <Route
              path={Routes.ApplicationDetails.path}
              component={ApplicationDetail}
            />
            <Route
              path={Routes.Users.usersList.path}
              component={UserPage}
            />
            <Route
              path={Routes.UserGroups.previewCondition}
              component={PreviewKeyCondition}
              exact={true}
            />
            <Route
              path={Routes.UserGroups.keyCondition}
              component={KeyCondition}
              exact={true}
            />
            <Route
              path={Routes.UserGroups.path}
              component={UserGroups}
              exact={true}
            />
            <Route
              path={Routes.InformationAssetDetails.path}
              component={InformationAssetDetail}
              exact={true}
            />
            <Route
              path={Routes.SystemUserGroupDetails.path}
              component={SystemUserGroupDetail}
              exact={true}
            />
            <Route
              path={Routes.InformationAssets.path}
              component={InformationAssetsUnderConstruction}
              exact={true}
            />
            <Route
              path={Routes.Policies.path}
              component={PolicyDetail}
              exact={true}
            />
            <Route
              path={Routes.Policies.createPath}
              component={ManagePolicy}
              exact={true}
            />
            <Route
              path={Routes.Policies.editPath}
              component={ManagePolicy}
              exact={true}
            />
            <Route
              path={Routes.UserGuide.path}
              component={UserGuide}
              exact={true}
            />
            <Route
              path={"/"}
              component={getHomePageComponent()}
              exact={true}
            />
            <Route>
              <Redirect to={Routes.NotFound.path}/>
            </Route>
          </Switch>
        </Layout.Content>
      </Layout>
    </div>
  );
};
